import {
  isMobio360,
  isMobizone360,
  isVibe360,
} from "../constants/multiDomains";

const mobio360Subdomain = ["ch", "pl", "lu", "fr"];
const mobizone360Subdomain = ["rs"];
const vibe360Subdomain = ["si"];

export const isWithdrawEnabled = (subdomain) => {
  return (
    (mobio360Subdomain.includes(subdomain) && isMobio360()) ||
    (mobizone360Subdomain.includes(subdomain) && isMobizone360()) ||
    (vibe360Subdomain.includes(subdomain) && isVibe360())
  );
};



// WEBPACK FOOTER //
// ./src/utils/withdrawContract.js